import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { ClaimFormProvider } from './context/ClaimFormContext.jsx'
import { PromoProvider } from './context/PromoContext.jsx'
import I18nSync from './components/I18nSync.jsx'
import './i18n.js'
import './index.css'
import { captureLandingQuery } from './utils/landingQuery.js'

captureLandingQuery()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <PromoProvider>
        <ClaimFormProvider>
          <I18nSync />
          <App />
        </ClaimFormProvider>
      </PromoProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
